import {
  append,
  ifElse,
  transduce,
  flip,
  compose,
  when,
  isEmpty,
  always,
  filter,
  identity,
  map,
  tap,
} from 'ramda';
import Logger from '../../../services/Logger';
import { checkWidgetPredicate, isPresentInWidgetsMap } from './filterWidgetMap';
import { recentToWidget } from './recentToWidget';
import { getAmsOrdering, orderIdToWidget } from './amsOrdering';

const logger = new Logger('useWidgets');

export function getWidgets(options) {
  const { isOrderingEnabled, commonConfig, segments } = options;
  const { widgets = [], segmentsOrdering } = commonConfig;

  try {
    const transform = compose(
      transduce(
        compose(
          map(recentToWidget(options)),
          filter(identity),
          filter(isPresentInWidgetsMap(options)),
          filter(checkWidgetPredicate(options))
        ),
        flip(append),
        []
      ),
      when(
        always(isOrderingEnabled),
        compose(
          ifElse(isEmpty, always(widgets), orderIdToWidget(widgets)),
          always(getAmsOrdering({ segmentsOrdering, segments }))
        )
      ),
      tap((v) => {
        if (isEmpty(v)) {
          logger.warn('No widgets found for commonConfigOrdering');
        }
      })
    );

    return transform(widgets);
  } catch (error) {
    logger.error('Error in getWidgets', error);
    return [];
  }
}
